import { Button, Typography, styled } from '@material-ui/core';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  position: 'relative',
  maxWidth: 1272,
  width: '100%',
  '&.filters-open': {
    maxWidth: 1616,
  },
}));

export const Toolbar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  minHeight: 40,
  background: theme.palette.common.white,
  padding: theme.spacing(1.5, 2),
  border: `1px solid ${theme.palette.border}`,
  borderRadius: 10,
}));

export const ProductsCount = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
}));

export const ContentRow = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  position: 'relative',
}));

export const MainContent = styled('div')(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const CardsWrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  // auto-fill keeps the empty tracks, so a short row still lines up with the
  // toolbar on the right instead of shrinking to its content.
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gap: theme.spacing(3),
}));

export const ShowFiltersButton = styled(Button)(({ theme }) => ({
  borderRadius: 10,
  color: theme.palette.text.primary,
  border: `1px solid ${theme.palette.border}`,
  backgroundColor: theme.palette.common.white,
  textTransform: 'capitalize',
  padding: theme.spacing(1, 2),
  '&.has-filters': {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '& .MuiButton-startIcon, & .MuiSvgIcon-root': {
      color: theme.palette.common.white,
    },
  },
}));

export const FilterCountBadge = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 20,
  height: 20,
  marginLeft: theme.spacing(1),
  padding: theme.spacing(0, 0.75),
  borderRadius: 10,
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: 1,
}));

export const LegendWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2.5),
  position: 'relative',
}));
